module.exports = "<div class=\"row list-header\"><div class=col-lg-12><div class=page-header><h1>Customers Segments</h1></div></div></div><div class=\"row list-view\"><div class=col-lg-12><table class=\"grid table table-condensed table-hover table-striped\"><thead><tr><th>Name<th class=ng-admin-column-actions>Actions<tbody><tr ng-repeat=\"segment in segments\"><td>{{ segment }}<td class=ng-admin-column-actions><ma-filtered-list-button entity-name=customers filter=\"{ groups: segment }\" size=xs></ma-filtered-list-button></table></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./js/segments/segmentsTemplate.html
 ** module id = 348
 ** module chunks = 0
 **/